module.exports = __webpack_public_path__ + "img/泗水滩底贡园.87904da4.png";